import { AppState } from 'reduxStore/appStore';
import { createSelector } from '@reduxjs/toolkit';
import { LoadingStateEnum } from 'model/Resource';

import { ResponseRateState, STORE_NAME } from './initialState';

export const selectResponseRateDomain = (state: AppState): ResponseRateState.Domain =>
  state[STORE_NAME];

export const selectResponseRateDomainData = createSelector(
  selectResponseRateDomain,
  (domain) => domain.data
);

export const selectResponseRateResourceByProjectId = (projectId: number) =>
  createSelector(selectResponseRateDomainData, (domain) => domain[projectId]);

export const selectResponseRateByProjectId = (projectId: number) =>
  createSelector(selectResponseRateResourceByProjectId(projectId), (resource) => resource?.data);

export const selectIsLoadingResponseRate = (projectId: number) =>
  createSelector(
    selectResponseRateResourceByProjectId(projectId),
    (resource) => resource?.loadingState === LoadingStateEnum.PENDING
  );

export const selectIsErrorResponseRate = (projectId: number) =>
  createSelector(
    selectResponseRateResourceByProjectId(projectId),
    (resource) => resource?.loadingState === LoadingStateEnum.REJECTED
  );
